module.exports = __webpack_public_path__ + "static/img/nothing.82dccec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nothing.png
// module id = pkH0
// module chunks = 1